<template>
  <div v-cloak id="EventContributorsBlock" class="EventContributorsBlock">
    <EventContributorsList
      v-if="event && event.contributors"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import EventContributorsList from "./components/EventContributorsList";

export default {
  name: 'EventContributorsBlock',
  components: {EventContributorsList},
  data() {
    return {
      translations: {
        information: Drupal.t('Information'),
        tickets: Drupal.t('Tickets')
      },
    }
  },
  computed: {
    ...mapGetters({
      eventData: "getEventData",
      showButton: "getTicketButtonState",
    }),
    event() {
      return this.eventData[drupalSettings.nid];
    },
  },
}
</script>
